// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Router from 'vue-router'
import VueCurrencyFilter from 'vue-currency-filter'
import moment from 'vue-moment'
import axios from 'axios'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import Contracts from './contracts'
import Login from './login'
import Contact from './contact'
import ContactForm from './contactform'
import PasswordReset from './passwordreset'
import Home from './home'
import ChangePassword from './changePW'
import IdleVue from 'idle-vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFilePdf, faExclamationTriangle, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import auth from './auth'
import Vuex from 'vuex'
import VeeValidate from 'vee-validate'

library.add(faFilePdf, faExclamationTriangle, faEye, faEyeSlash)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(axios)
Vue.use(moment)
Vue.use(Router)
Vue.use(VueCurrencyFilter,
  {
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
  })
Vue.use(VeeValidate,
  {
    inject: true,
    fieldsBagName: 'veeFields'
  }
)

const routes = [
  { path: '/', redirect: '/home' },
  { path: '/home', component: Home },
  { path: '/contracts', component: Contracts },
  { path: '/login', component: Login },
  { path: '/contact', component: Contact },
  { path: '/contactform', component: ContactForm },
  { path: '/passwordreset', component: PasswordReset },
  { path: '/changepassword', component: ChangePassword }
]

export var router = new Router({
  mode: 'history',
  routes
})

localStorage.setItem('apiURL', process.env.API_URL)

Vue.use(Vuex)

const eventsHub = new Vue()
const store = new Vuex.Store({
})

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 3000000
})
// eslint-disable-next-line
const app = new Vue({
  el: '#app',
  store,
  router: router,
  onIdle () {
    auth.logout()
    this.$router.push('/login')
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js